import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormArray, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { Kpi, Unit } from '@tran-monorepo/interfaces/applications';
import { HelpComponent } from '../../help';
import { FormArrayComponent } from '../form-array';
import { createKpiSelectorForm, KpiSelectorComponent, KpiSelectorFormGroup } from '../kpi-selector';
import { toKpiGridRows } from './kpi-form-array.utils';

@Component({
    selector: 'tran-kpi-form-array',
    imports: [
        ReactiveFormsModule,
        TranslateModule,
        SiFormItemComponent,
        HelpComponent,
        FormArrayComponent,
        KpiSelectorComponent
    ],
    templateUrl: './kpi-form-array.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiFormArrayComponent {
    public readonly control = input.required<FormArray<KpiSelectorFormGroup>>();
    public readonly rowsKpis = input<Kpi[]>([]);
    public readonly optionsKpis = input<Kpi[]>([]);
    public readonly units = input<Unit[]>([]);
    public readonly label = input<string>('');
    public readonly helpTitle = input<string>('');
    public readonly helpText = input<string>('');
    public readonly submitted = input(false);
    public readonly readonly = input(false);

    protected readonly rows = computed(() => toKpiGridRows(this.rowsKpis()));
    protected readonly createControl = (): KpiSelectorFormGroup =>
        createKpiSelectorForm({ validators: Validators.required });
}
